import React from "react";
import { theme } from "./theme";

type ResizeHandleProps = {
  position: "left" | "right";
  framePosition: number;
  totalFrames: number;
  clientWidth: number;
  onMouseDown: (e: React.MouseEvent) => void;
  isDragging: boolean;
};

export const ResizeHandle: React.FC<ResizeHandleProps> = ({
  position,
  framePosition,
  totalFrames,
  clientWidth,
  onMouseDown,
  isDragging,
}) => {
  const style = position === "left"
    ? {
      left: 0,
      borderRadius: "8px 0px 0px 8px",
    }
    : {
      right: 0,
      borderRadius: "0px 8px 8px 0px",
    }
  return (
    <div
      id={`incident-editor-${position}`}
      style={
        {
          ...{
            position: "absolute",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: theme.sizes.handleWidth,
            backgroundColor: "rgb(25, 118, 210)",
            // borderRadius: "8px 0 0 8px",
            height: theme.sizes.handleHeight,
            border: `1px solid rgb(25, 118, 210)`,
            // cursor: isDragging ? "grabbing" : "grab",
            cursor: "ew-resize",
            // left: `calc(${(framePosition * clientWidth) / totalFrames}px - 5px)`,
            // left: 0,
            // right: 0,
            zIndex: theme.zIndex.handle,
            top: 0
          },
          ...style
        }
      }
      onMouseDown={onMouseDown}
    >
      <div style={{
        height: "50%",
        width: "2px",
        backgroundColor: "white"
      }} />
    </div>
  );
};
